import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

// Import components
import GroupPageShell from "../components/common/GroupPageShell";
import Introduction from "../components/AlYasminah/AlYasminahIntro";
import Services from "../components/AlYasminah/AlYasminahServices";
import WhyChooseUs from "../components/AlYasminah/AlYasminahWhy";
import Contact from "../components/AlYasminah/AlYasminahContact";

const AlYasminah: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [content, setContent] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const { t, t_api } = useLanguage();

    useEffect(() => {
        fetch('/api/homepage/content')
            .then(res => res.json())
            .then(data => {
                setContent(data.AlYasminah || {});
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    // Get current tab from URL, fallback "about"
    const activeTab = searchParams.get("tab") || "about";

    const menuItems = [
        { id: "about", label: t('common.about') },
        { id: "services", label: t('common.services') },
        { id: "why_us", label: t('common.why_us') },
        { id: "contact", label: t('common.contact') },
    ];

    if (loading) return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="w-16 h-16 border-4 border-red-50 border-t-red-600 rounded-full animate-spin mb-6" />
            <p className="text-gray-500 font-medium">{t('common.loading')}</p>
        </div>
    );

    const T = content || {};

    return (
        <GroupPageShell
            heroContent={{
                title: t_api(T.banner_title, T.banner_title_ar),
                subtitle: t_api(T.banner_subtitle, T.banner_subtitle_ar),
                banners: [
                    { image: T.banner_1 || '/banner/alyasminah_1.jpg' },
                    { image: T.banner_2 || '/banner/alyasminah_2.jpg' },
                    { image: T.banner_3 || '/banner/alyasminah_3.jpg' },
                ]
            }}
            tabs={menuItems}
            activeTab={activeTab}
            onTabChange={(tabId) => setSearchParams({ tab: tabId })}
        >
            <div className="mt-8 mb-16">
                {activeTab === "about" && (
                    <Introduction content={{
                        title: t_api(T.about_title, T.about_title_ar),
                        desc: t_api(T.about_desc, T.about_desc_ar),
                        image: T.about_image,
                    }} />
                )}
                {activeTab === "services" && (
                    <Services content={T} />
                )}
                {activeTab === "why_us" && (
                    <WhyChooseUs content={T} />
                )}
                {activeTab === "contact" && (
                    <Contact content={T} />
                )}
            </div>
        </GroupPageShell>
    );
};

export default AlYasminah;
